import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import GuestRoute from "./GuestRoute";



// Guest pages (login, register, etc.)
const Login = lazy(() => import("../pages/auth/Login"));
const Register = lazy(() => import("../pages/auth/Register"));
const SplashScreen = lazy(() => import("../pages/SplashScreen"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const NewPassword = lazy(() => import("../pages/auth/NewPassword"));
const OtpVerification = lazy(() => import("../pages/auth/OtpVerification"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Collectors = lazy(() => import("../pages/collectors/Collectors"));
const Customers = lazy(() => import("../pages/customers/Customer"));
const AddCustomer = lazy(() => import("../pages/customers/AddCustomer"));
const EditCustomer = lazy(() => import("../pages/customers/EditCustomer"));
const SchedulePickup = lazy(() => import("../pages/customers/SchedulePickup"));
const Drivers = lazy(() => import("../pages/drivers/Drivers"));
const AddDriver = lazy(() => import("../pages/drivers/AddDriver"));
const EditDriver=lazy(()=>import("../pages/drivers/EditDriver"));
const Fleets = lazy(() => import("../pages/Fleets/Fleets"));
const AddFleet = lazy(() => import("../pages/Fleets/AddFleet"));
const EditFleet = lazy(() => import("../pages/Fleets/EditFleet"));
const Complaints=lazy(()=> import("../pages/complaints/Complaints"))
const Notifications=lazy(()=>import("../pages/Notifications/Notifications"))
const Settings=lazy(()=>import("../pages/settings/Settings"))
const WeighBridgeRecords=lazy(()=>import("../pages/weighbridgerecords/WeighBridgeRecords"))
const Payments=lazy(()=>import("../pages/PaymentManagement/Payments"))
const HandoverLogs= lazy(()=>import("../pages/PaymentManagement/HandoverLogs"))


const guestRoutes = [
  {
    path: "/login",
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <GuestRoute>
        <Register />
      </GuestRoute>
    ),
  },
  {
    path: "/",
    element: (
      <GuestRoute>
        <Navigate to="/login" replace />
      </GuestRoute>
    ),
  },
  {
    path: "/splashscreen",
    element: (
      <GuestRoute>
        <SplashScreen />
      </GuestRoute>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <GuestRoute>
        <ResetPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/new-password",
    element: (
      <GuestRoute>
        <NewPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/otp-verification",
    element: (
      <GuestRoute>
        <OtpVerification />
      </GuestRoute>
    ),
  },
  //   {
  //   path: "/dashboard",
  //   element: (
  //     <GuestRoute>
  //       <Dashboard />
  //    </GuestRoute>
  //   ),
  // },
  //   {
  //   path: "/customers",
  //   element: (
  //     <GuestRoute>
  //       <Customers />
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path: "/customers/add",
  //   element: (
  //     <GuestRoute>
  //       <AddCustomer />
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path: "/customers/edit/:slug",
  //   element: (
  //     <GuestRoute>
  //       <EditCustomer />
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path: "/customers/schedule-pickup",
  //   element: (
  //     <GuestRoute>
  //       <SchedulePickup />
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path: "/collectors",
  //   element: (
  //     <GuestRoute>
  //       <Collectors />
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path: "/",
  //   element: (
  //     <GuestRoute>
  //       <Navigate to="/dashboard" replace />
  //     </GuestRoute>
  //   ),
  // },

  // {
  //   path:"/drivers",
  //   element:(
  //     <GuestRoute>
  //       <Drivers/>
  //     </GuestRoute>
  //     )
  // },
  // {
  //   path:"/drivers/add",
  //   element:(
  //     <GuestRoute>
  //       <AddDriver/>
  //     </GuestRoute> 
  //     )
  // },
  // {
  //   path:"/drivers/edit/:slug",
  //   element:(
  //     <GuestRoute>
  //       <EditDriver/>
  //     </GuestRoute> 
  //     )
  // },
  // {
  //   path: "/fleet-management",
  //   element: (
  //     <GuestRoute>
  //       <Fleets/>
  //     </GuestRoute>
  //   )
  // },
  //   {
  //   path:"/fleets/add",
  //   element:(
  //     <GuestRoute>
  //       <AddFleet/>
  //     </GuestRoute> 
  //     )
  // },
  //   {
  //   path:"/fleets/edit/:slug",
  //   element:(
  //     <GuestRoute>
  //       <EditFleet/>
  //     </GuestRoute> 
  //     )
  // },
  // {
  //   path: '/complaints',
  //   element: (
  //     <GuestRoute>
  //       <Complaints />
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path:"/notifications",
  //   element:(
  //     <GuestRoute>
  //       <Notifications/>
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path:"/settings",
  //   element:(
  //     <GuestRoute>
  //       <Settings/>
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path:"/weighbridge-records",
  //   element:(
  //     <GuestRoute>
  //       <WeighBridgeRecords/>
  //     </GuestRoute>
  //   ),
  // },
  // {
  //   path:"/payment-management",
  //   element:(
  //     <GuestRoute>
  //    <Payments/>
  //     </GuestRoute>
  //   )
  // },
  //  {
  //   path:"/handover-logs",
  //   element:(
  //     <GuestRoute>
  //    <HandoverLogs/>
  //     </GuestRoute>
  //   )
  // }



];

export default guestRoutes;
